import { render, staticRenderFns } from "./branchForm.vue?vue&type=template&id=5414722e&scoped=true&"
import script from "./branchForm.vue?vue&type=script&lang=js&"
export * from "./branchForm.vue?vue&type=script&lang=js&"
import style0 from "./branchForm.vue?vue&type=style&index=0&id=5414722e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5414722e",
  null
  
)

export default component.exports